type ShortcutTarget = {
  tagName: string;
  isContentEditable: boolean;
  closest: (selector: string) => ShortcutTarget | null;
};

function asShortcutTarget(target: EventTarget | null): ShortcutTarget | null {
  if (target === null || typeof target !== "object") {
    return null;
  }
  const candidate = target as Partial<ShortcutTarget>;
  if (
    typeof candidate.tagName !== "string"
    || typeof candidate.isContentEditable !== "boolean"
    || typeof candidate.closest !== "function"
  ) {
    return null;
  }
  return candidate as ShortcutTarget;
}

/** True when Space should toggle playback (not activate a focused control). */
export function shouldTimelineSpaceTogglePlay(target: EventTarget | null): boolean {
  const el = asShortcutTarget(target);
  if (el === null) {
    return false;
  }
  if (el.isContentEditable) {
    return false;
  }
  const tag = el.tagName;
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || tag === "BUTTON") {
    return false;
  }
  if (tag === "A") {
    return false;
  }
  if (el.closest("select, button, a[href], [role='combobox'], [role='listbox']")) {
    return false;
  }
  return true;
}

/** Which way an arrow key scrubs, or null when it belongs to the browser or a control. */
export function timelineArrowScrubDirection(event: {
  key: string;
  target: EventTarget | null;
  altKey: boolean;
  ctrlKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
}): -1 | 1 | null {
  if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
    return null;
  }
  const direction = event.key === "ArrowRight" ? 1 : event.key === "ArrowLeft" ? -1 : null;
  if (direction === null) {
    return null;
  }
  const el = asShortcutTarget(event.target);
  if (
    el === null
    || el.isContentEditable
    || el.closest("input, select, textarea") !== null
  ) {
    return null;
  }
  return direction;
}
